const { identity } = require("lodash");

// helper object for setting up NoUI sliders
let sliders = {
    inputs: [],
    init: function(id, options) {
        // create the slider
        this.inputs[id] = noUiSlider.create(
            document.querySelector('#slider__' + id),
            options
        );
        //set up handlers
        if( typeof( options.start ) == 'number' ) {
            // update label (using getElementById.innerHTML for performance)
            this.inputs[id].on('update', function(value) {
                document.getElementById('slider-value__' + id).innerHTML = +value;
            });
            // update Store (debounced for performance)
            this.inputs[id].on('update', _.debounce( function(value) {
                Spruce.store('inputs').set(id, +value);
            }, 500));
        } else {
            // update labels (using getElementById.innerHTML for performance)
            this.inputs[id].on('update', function (values, handle) {
                let v = +values[handle];
                let suffix = '';

                document.getElementById('slider-value-' + (handle === 0 ? 'min' : 'max') + '__' + id).innerHTML = v + suffix;
            });
            // update Store (debounced for performance)
            this.inputs[id].on('update', _.debounce( function (values, handle) {
                let current = Spruce.store('inputs').current[id];
                if (handle === 0) {
                    Spruce.store('inputs').set( id, {
                        min: +values[handle],
                        max: +current.max
                    });
                } else {
                    Spruce.store('inputs').set(id, {
                        min: +current.min,
                        max: +values[handle]
                    });
                }
            }, 500));
        }
    },
    set: function(id, value) {
        this.inputs[id].set(value);
    },
    updateOptions: function(id, newOptions) {
        this.inputs[id].updateOptions(newOptions, false);
    }
};

// the stat box Alpine object
window.appRankings = () => {
    return {
        players: [],
        activeMenus: [],
        leagues: [],


        /*
         * Initialise
         */
        init: function() {

            // africa extra sliders
            if( africaMen() ) {

                // initialise global filters
                Spruce.store('inputs', {
                    current: {},
                    defaults: {
                        age: { min: 15, max: 35 },
                        minutesPlayed: { min: 0, max: 5000 },
                    },
                    set(key, value) {
                        this.current[key] = value;
                    },
                    reset() {
                        this.current = {...this.defaults};
                    }
                });
                this.$store.inputs.reset();

                this.$nextTick( () => {
                    sliders.init('age', {
                        start: [+this.$store.inputs.current.age.min, +this.$store.inputs.current.age.max],
                        connect: true,
                        step: 2,
                        margin: 2,
                        range: { min: 15, max: 35 }
                    });
                    sliders.init('minutesPlayed', {
                        start: [+this.$store.inputs.current.minutesPlayed.min, +this.$store.inputs.current.minutesPlayed.max],
                        connect: true,
                        step: 50,
                        margin: 50,
                        range: { min: 0, max: 5000 }
                    });
                });
            }

            this.$nextTick(() => {

                $c('selectSeason').set($c('selectSeason').items[0]);

                $c('appMain').loading = true;
                this.loadLeagues();
            });

            if(elite()) {
                Spruce.watch('season', () => this.loadPlayers());
            }
            Spruce.watch('league', () => this.loadPlayers());
            Spruce.watch('position', () => this.loadPlayers());
            if( africaMen() ) {
                Spruce.watch('inputs.current', () => this.loadPlayers());
            }

            // Testing only
            // this.$store.league = 255;
            // this.$store.position = 'ST';
            // this.loadPlayers()
        },

        loadLeagues: function() {
            axios.get('/api/leagues/')
                .then( response => {
                    let r = [];
                    const leagues = Object.create( response.data );
                    leagues.forEach( league => {
                        r.push({
                            value: league.id,
                            label: league.name,
                            icon: icon(nationFlag(league.country.id))
                        });
                    });
                    $c('selectLeague').items = r;

                    $c('appMain').loading = false;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        /*
         * Loads in the saved players from the API
         */
        loadPlayers: function() {
            console.log('at loadPlayers');
            if( ! this.$store.league || ! this.$store.position ) {
                return;
            }

            $c('appMain').loading = true;

            let path = [
                '/api/rankings',
                this.$store.season,
                this.$store.league,
                this.$store.position
            ];
            if(africaMen()) {
                path = [
                    ...path,
                    this.$store.inputs.current.age.min,
                    this.$store.inputs.current.age.max,
                    this.$store.inputs.current.minutesPlayed.min,
                    this.$store.inputs.current.minutesPlayed.max,
                ]
            }
            axios.get(buildPath(path))
                .then( response => {
                    this.players = response.data;
                    $c('appMain').loading = false;
                })
                .catch( ajaxFail )
        },


        /*
         * Filter and sort the players
         */
        get filteredPlayers() {
            let r = [...this.players];

            // sort by age or value
            if( this.$store.sort == 'none' ) {
                return r;
            } else if( this.$store.sort == 'ageAsc' ) {
                r.sort( (a, b) => +a.age === +b.age ? 0 : (+a.age > +b.age) ? 1 : -1 );
            } else if( this.$store.sort == 'ageDesc' ) {
                r.sort( (a, b) => +a.age === +b.age ? 0 : (+a.age > +b.age) ? -1 : 1 );
            } else if( this.$store.sort == 'valueAsc' ) {
                r.sort( (a, b) => +a.value === +b.value ? 0 : (+a.value > +b.value) ? 1 : -1 );
            } else if( this.$store.sort == 'valueDesc' ) {
                r.sort( (a, b) => +a.value === +b.value ? 0 : (+a.value > +b.value) ? -1 : 1 );
            } else if( this.$store.sort == 'minutesAsc' ) {
                r.sort( (a, b) => +a.minutesPlayed === +b.minutesPlayed ? 0 : (+a.minutesPlayed > +b.minutesPlayed) ? 1 : -1 );
            } else if( this.$store.sort == 'minutesDesc' ) {
                r.sort( (a, b) => +a.minutesPlayed === +b.minutesPlayed ? 0 : (+a.minutesPlayed > +b.minutesPlayed) ? -1 : 1 );
            }
            return r;
        }
    }
};
